import React, { useEffect, useRef, useState } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import moment from "moment";
import EmployeePayrollIncrementComponentFilter from "./EmployeePayrollIncrementComponentFilter";
import { FaSpinner } from "react-icons/fa";

const EmployeePayrollIncrementComponent = ({
  data,
  selectedResource,
  selectAllChecked,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  handleGetData,
  handleAddNew,
  isApiStatus,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleAmountChange,
  payrollLineData = [],
  copyPreviousAmount = false,
  totalOldAmount = 0,
  totalAmount = 0,
  isSubmitting = false // Added this prop
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const inputRef = useRef(null);
  const tdRef = useRef(null);
  console.log("  isApiStatus", isApiStatus);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tdRef.current && !tdRef.current.contains(event.target)) {
        setEditingIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (editingIndex !== null && inputRef.current) {
      inputRef.current.select();
    }
  }, [editingIndex]);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-2">
        <div className="d-flex">
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <EmployeePayrollIncrementComponentFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Submit</Tooltip>}
            >
              <button 
                id="Add-btn" 
                onClick={handleAddNew}
                disabled={isSubmitting} // Disable button when submitting
                style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              >
                {isSubmitting ? (
                  <>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className="table-responsive mb-2">
        <Table bordered striped>
          <thead id="thcolor">
            <tr className="text-center">
              <th>Payroll Code</th>
              <th>Payroll</th>
              <th>Formula</th>
              <th>Previous Amount</th>
              <th>
                Total Amount
                <br />
                <input
                  type="checkbox"
                  className="me-1"
                  checked={copyPreviousAmount}
                  onChange={handleCheckboxChange}
                />
                Copy Previous Amount
              </th>
            </tr>
          </thead>
          {isApiStatus === undefined && payrollLineData?.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={5} className="text-center">
                  <div>
                    <p>
                      <FaSpinner className="spinner" />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          ) : isApiStatus === 200 && payrollLineData?.length > 0 ? (
            <tbody>
              {payrollLineData.map((ele, index) => {
                const isNonEditable =
                  ele?.Amount == null ||
                  isNaN(ele?.Formula) ||
                  ele?.PayrollType_054 === 619;
                const isEditing = editingIndex === index;

                return (
                  <tr key={index}>
                    <td style={{ fontWeight: isNonEditable ? "bold" : "" }}>
                      {ele?.PayrollCode}
                    </td>
                    <td style={{ fontWeight: isNonEditable ? "bold" : "" }}>
                      {ele?.Payroll}
                    </td>
                    <td style={{ fontWeight: isNonEditable ? "bold" : "" }}>
                      {ele?.Formula}
                    </td>
                    <td className="text-end" style={{ fontWeight: isNonEditable ? "bold" : "" }}>
                      {ele?.OldAmount}
                    </td>
                    <td
                      className="text-end"
                      style={{ fontWeight: isNonEditable ? "bold" : "" }}
                      onClick={() => {
                        if (!isNonEditable) {
                          setEditingIndex(index);
                        }
                      }}
                      ref={tdRef}
                    >
                      {isEditing ? (
                        <input
                          type="number"
                          className="form-control text-end"
                          value={ele?.Amount || "0.00"}
                          onChange={(e) => handleAmountChange(index, e)}
                          autoFocus
                          ref={inputRef}
                          onBlur={() => setEditingIndex(null)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setEditingIndex(null);
                            }
                            // Prevent number change with arrow keys
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          // Prevent number change with mouse wheel
                          onWheel={(e) => e.preventDefault()} />
                      ) : (
                        typeof ele?.Amount === "number" ? ele.Amount.toFixed(2) : "0.00"
                      )}
                    </td>
                  </tr>
                );
              })}

              <tr>
                <td></td>
                <td className="fw-bold">Total</td>
                <td></td>
                <td className="fw-bold text-end">{totalOldAmount.toFixed(2)}</td>
                <td className="fw-bold text-end">{totalAmount.toFixed(2)}</td>
              </tr>
            </tbody>
          ) : isApiStatus === 200 && payrollLineData?.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={5} className="text-center">
                  No Data Found
                </td>
              </tr>
            </tbody>
          )
            : payrollLineData?.length === 0 ? <tbody>
              <tr>
                <td colSpan={5} className="text-center">
                  No Data Found
                </td>
              </tr>
            </tbody> : isApiStatus === undefined ? (<tbody>
              <tr>
                <td colSpan={5} className="text-center">
                  <div>
                    <p>
                      <FaSpinner className="spinner" />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>) : null}
        </Table>
      </div>
    </div>
  );
};

export default EmployeePayrollIncrementComponent;